import type { RecordJobSeenInput } from "../../../__generated__/types.gqlgenerated";

import {
  RecordJobSeenDocument,
  type RecordJobSeenMutation,
  type RecordJobSeenMutationVariables,
} from "../../../homepage/graphQL/mutations/__generated__/recordJobSeen.gqlgenerated";

import { useApolloClient } from "@apollo/client";
import { useCallback } from "react";

/**
 * Fires the UIL `recordJobSeen` mutation for a findRelevantJobs (RJP) surface.
 * Unlike the SERP/homepage `useJobSeenLogger`, RJP surfaces send the *raw*
 * per-result `RelevantJobsResult.trackingKey` (schema: "should be used when
 * generating user events via the UIL one graph mutations") rather than a
 * client-synthesized v5 key. This is the key the rjpImpressions seen join
 * reconstructs `seen` from (RN-3042).
 */
export const useRelevantJobsSeenLogger = () => {
  const client = useApolloClient();

  return useCallback(
    (jobResultTrackingKey: string): void => {
      if (!jobResultTrackingKey) return;

      const input: RecordJobSeenInput = {
        jobSeenElements: [{ jobResultTrackingKey, timestamp: Date.now() }],
      };

      client
        .mutate<RecordJobSeenMutation, RecordJobSeenMutationVariables>({
          mutation: RecordJobSeenDocument,
          variables: { input },
        })
        .catch((error) => {
          console.error("[useRelevantJobsSeenLogger] recordJobSeen failed", error);
        });
    },
    [client],
  );
};
